import { RESERVATION_LIST } from "../../data/reservation";

export default {
  title: '取得商家預約列表',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": RESERVATION_LIST
        }
      }
    },
  ]
}

